// extracted by mini-css-extract-plugin
export default {"websiteCell":"subscriptions-table_websiteCell__9kdZq","websiteName":"subscriptions-table_websiteName__e-Ljl","subscriptionType":"subscriptions-table_subscriptionType__TaUcZ"};